import type { FC } from 'react'
import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { handleOAuthRedirect } from '../features/auth/authSlice'
import { useAppDispatch } from '../hooks'
import { showError, toAppError } from '../utils/ErrorHandler'
import { AppErrorCode } from '../types/error.types'
import { LoadingIndicator } from '../components/LoadingIndicator/LoadingIndicator'

const OAuthRedirectPage: FC = () => {
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  useEffect(() => {
    const completeLogin = async () => {
      const result = await dispatch(handleOAuthRedirect({ search: location.search }))

      if (handleOAuthRedirect.fulfilled.match(result)) {
        navigate('/vehicles', { replace: true })
        return
      }

      const appError =
        result.payload ?? toAppError(result.error, { fallbackMessage: 'Could not complete login.' })

      showError(appError)

      navigate(appError.code === AppErrorCode.UNAUTHORIZED ? '/' : '/error', {
        replace: true,
      })
    }

    completeLogin().catch((error) => {
      const appError = toAppError(error, {
        fallbackCode: AppErrorCode.GENERIC_ERROR,
        fallbackMessage: 'An unexpected error occurred during login.',
      })

      showError(appError)
      navigate('/error', { replace: true })
    })
  }, [dispatch, location.search, navigate])

  return (
    <div style={{ display: 'grid', placeItems: 'center', height: '60vh' }}>
      <LoadingIndicator style="DEFAULT" />
    </div>
  )
}

export default OAuthRedirectPage
